/**
 * Catálogo estático de los tipos de formulario disponibles para el
 * registro de vivienda / visita. A diferencia de las encuestas
 * dinámicas (`GET /v1/surveys`, ver `surveyService.js`), estos tipos
 * son fijos en el negocio y cada uno corresponde a un `slug` que se
 * consulta contra `GET /v1/surveys/:slug` (ver `dynamicFormService.js`).
 */
export const FORM_TYPES = [
  {
    id: 1,
    slug: 'house-registration',
    label: 'Registro de vivienda',
    description: 'Formulario para registrar la ubicación y referencia de una vivienda.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 2,
    slug: 'visit-result',
    label: 'Resultado de la visita',
    description: 'Formulario para registrar el resultado obtenido durante una visita a una vivienda.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 3,
    slug: 'conversation',
    label: 'Conversación con el ciudadano',
    description: 'Formulario para registrar la información obtenida durante la conversación con el ciudadano.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 4,
    slug: 'vote-intention',
    label: 'Intención del voto',
    description: 'Formulario para registrar la preferencia electoral y el nivel de decisión expresado por el ciudadano.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 5,
    slug: 'citizen-data',
    label: 'Datos del ciudadano',
    description: 'Formulario para solicitar autorización y registrar los datos personales y electorales proporcionados voluntariamente por el ciudadano.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 6,
    slug: 'community-participation',
    label: 'Participación comunitaria',
    description: 'Formulario para registrar el interés del ciudadano en participar en actividades comunitarias.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
  {
    id: 7,
    slug: 'follow-up-closing',
    label: 'Seguimiento y cierre',
    description: 'Formulario para registrar si la visita requiere seguimiento, la fecha sugerida y las observaciones finales del capturista.',
    updatedAt: '2026-07-22T16:11:31.000000Z',
  },
];

/** Formularios de la conversación con el ciudadano (del 4 al 7). */
export const VISIT_FORMS = FORM_TYPES.filter((form) => form.id >= 4 && form.id <= 7);

/** Busca un tipo de formulario por su `slug`, o `undefined` si no existe. */
export function getFormTypeBySlug(slug) {
  return FORM_TYPES.find((formType) => formType.slug === slug);
}

